import { cardItems } from '@/mocks/animeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            新番速递
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            最新上架热门动漫，每一部都值得加入书架
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {cardItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}